export enum BarOrientation {
  Vertical = 'vertical',
  Horizontal = 'horizontal'
}
